import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const COLORS = { admin: "#232D4F", instructor: "#232D4F", student: "#1E9E2A" };

export function avatarUrl(avatar) {
  if (!avatar) return "";
  return avatar.startsWith("http") ? avatar : `${BACKEND}${avatar}`;
}

export const UserAvatar = ({ user, size = 36, className = "" }) => {
  const src = avatarUrl(user?.avatar);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  if (src) {
    return <img src={src} alt={user?.name || ""} style={style} className={`rounded-full object-cover bg-white ring-1 ring-slate-200 ${className}`} />;
  }
  return (
    <div
      style={{ ...style, background: COLORS[user?.role] || "#232D4F" }}
      className={`rounded-full grid place-items-center text-white font-bold shrink-0 ${className}`}
    >
      {(user?.name || user?.email || "?").charAt(0).toUpperCase()}
    </div>
  );
};

export function roleLabel(user) {
  if (!user) return "";
  if (user.role === "admin") return "Administrador(a)";
  if (user.role === "instructor")
    return { professor: "Professor(a)", instrutor: "Instrutor(a)", mentor: "Mentor(a)", representante: "Representante Credenciado" }[user.profile] || "Professor(a)";
  return "Aluno(a)";
}
